<template>
  <div show.async="show">
    <div class="mt-20">
      <!-- <div class="header">
        <h2>合同信息</h2>
      </div> -->
      <ul class="item-list" v-if="order.contracts.length > 0">
        <li
          class="mb-30"
          v-for="(contract, index) in order.contracts"
          :key="contract.id"
        >
          <div>
            <span
              >{{ contract.user_id ? '原始' : '客户签章' }}合同：{{
                contract.name
              }}</span
            >
            <a
              :href="contract.url + `?t=${FileToken}`"
              :download="contract.name"
              class="ml-10"
              v-permission="Auth.orderAgreementDownload"
              >下载</a
            >
            <template
              v-if="
                order.deleted == 0 && order.status == 4 && contract.user_id > 0
              "
            >
              <el-button
                type="text"
                class="ml-10 pd-0"
                @click="startContractFormer(index)"
                v-permission="Auth.orderAgreementNew"
                >重新上传</el-button
              >
              <br />
              <span>
                小程序分享链接：<span
                  class="text-primary pointer"
                  @click="handleGetMPUrl"
                  >{{ miniUrL || '点击获取' }}</span
                >
                <span
                  class="pointer ml-10"
                  v-clipboard="miniUrL"
                  @success="copySuccess('copyTip')"
                  v-if="miniUrL"
                  >{{ copyTip }}</span
                >
              </span>
            </template>
            <br />
            <span class="text-info-12">
              {{ contract.user.name }}
              {{ formatTime(contract.updated_at) }}
            </span>
          </div>
        </li>
      </ul>
      <div class="mt-20" v-if="order.contracts.length == 0">
        <el-button
          v-if="order.deleted == 0"
          type="primary"
          size="mini"
          @click="startContractFormer()"
          v-permission="Auth.orderAgreementNew"
          >添加合同</el-button
        >
      </div>
    </div>
    <contract-former
      :show.sync="contractFormerVisibile"
      :model="contractForm"
      @created="createdContract"
    ></contract-former>
  </div>
</template>

<script>
import { getMPUrl } from '../../service/getData'
import { formatTime } from '@/util/index'
import ContractFormer from '@/components/contract'
import VueClipboards from 'vue-clipboards'
import Vue from 'vue'
Vue.use(VueClipboards)

export default {
  components: { ContractFormer },
  props: {
    order: {
      type: Object,
    },
    customerOrderID: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatTime,
      contractFormerVisibile: false,
      contractForm: {},
      editIndex: -1,
      miniUrL: '',
      copyTip: '复制',
    }
  },
  watch: {},
  methods: {
    startContractFormer(index = -1) {
      this.contractForm = {
        customer_order_id: this.order.id,
        name: null,
        url: null,
      }
      this.editIndex = index
      this.contractFormerVisibile = true
    },
    createdContract(contract) {
      if (this.editIndex > -1) {
        this.order.contracts[this.editIndex] = contract
      } else {
        this.order.contracts.unshift(contract)
      }
    },

    async handleGetMPUrl() {
      if (this.miniUrL) {
        return
      }
      let res = await getMPUrl({
        order_id: this.order.id,
        category: 'cutomer_order_contract',
        token_validate: false,
      })
      if (res.code == 0) {
        this.miniUrL = res.data
      }
    },
    copySuccess(param) {
      this[param] = '复制成功'
      let that = this
      setTimeout(function () {
        that[param] = '复制'
      }, 1000)
    },
  },
}
</script>

<style scoped>
.el-date-editor .el-range-input {
  width: 100px !important;
}
</style>